import React, { useState } from 'react';
import { BackArrow } from "../../shared/svgIcons.jsx";
import styled from '@emotion/styled';

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: .5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;


export default ({ returnToStep }) => {
  const connectUrl = '/connect'

  return (<div>
    <BackWrapper
      data-track="form-back"
      data-track-form-name="Warranty Registration"
      data-track-form-step="step 2 - go to occonnect"
      onClick={returnToStep}>
      <BackArrow width="21" height="12" />
      <h3>Back</h3>
      <BackText>What's your email?</BackText>
    </BackWrapper>
    <p>We noticed that you have an OCConnect Account. Please log in to register this warranty</p>
    <a
      data-track="form-advance"
      data-track-form-name="Warranty Registration"
      data-track-form-step="step 2 - go to occonnect"
      className="oc-cta-button refresh-cta" href={connectUrl}>
        Go to OCConnect
    </a>
  </div>
  )
}
